export class ScaleRangeModel {
    constructor(id, min, max) {
        this.scaleId = "";
        this.minValue = 0;
        this.maxValue = 0;
        this.scaleId = id;
        this.minValue = min;
        this.maxValue = max;
        if (min > max) {
            this.maxValue = min;
            this.minValue = max;
        }
    }
}
